// src/admin/data/doctorSpecializations.js
export const doctorSpecializations = [
    "General Physician (MBBS, MD)",
    "Family Medicine Specialist",
    "Internal Medicine Specialist (Internist)",
    "Cardiologist",
    "Interventional Cardiologist",
    "Neurologist",
    "Neurosurgeon",
    "Orthopedic Surgeon",
    "Spine Surgeon",
    "Sports Medicine Specialist",
    "Gastroenterologist",
    "Hepatologist",
    "Pulmonologist",
    "Nephrologist",
    "Endocrinologist",
    "Rheumatologist",
    "Dermatologist",
    "Ophthalmologist",
    "Optometrist",
    "ENT Specialist (Otolaryngologist)",
    "Dentist",
    "Orthodontist",
    "Periodontist",
    "Endodontist",
    "Urologist",
    "Andrologist",
    "Gynecologist",
    "Obstetrician",
    "Pediatrician",
    "Oncologist",
    "Surgical Oncologist",
    "Radiation Oncologist",
    "Psychiatrist",
    "Psychologist",
    "Plastic Surgeon",
    "Anesthesiologist",
    "Infectious Disease Specialist",
    "Immunologist",
    "Hematologist",
    "Geriatrician",
    "Emergency Medicine Specialist",
    "Intensivist (Critical Care Specialist)",
    "Ayurvedic Doctor",
    "Homeopathic Doctor",
    "Physiotherapist",
    "Dietitian/Nutritionist"
  ];